import React, { Component } from "react";
import auth from "../services/authService";
import config from "../config.json";

class LoginForm extends Component {
  state = {};
  state = {
    data: {},
  };

  componentDidMount = () => {
    const stayConnected = localStorage.getItem("stayConnected") === "true";
    this.setState({ stayConnected });
  };

  handleSubmit = (data) => {
    console.log("data", this.state.data);
    auth.login(this.state.data.login, this.state.data.password, true);
    return false;
  };

  handleChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;

    this.setState({ data });
  };

  handleCheckbox = ({ currentTarget: input }) => {
    localStorage.setItem("stayConnected", input.checked);
    this.setState({ stayConnected: input.checked });
  };

  render() {
    const { stayConnected } = this.state;
    return (
      <section id="wrapper" style={{ height: "100vh" }}>
        <div
          className="login-register"
          style={{
            backgroundImage: "url(" + config.backgroundImage + ")",
            backgroundPosition: "center center",
            height: "100vh",
            backgroundSize: "cover",
          }}
        >
          <div
            className="login-box card"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="card-body">
              <form
                className="form-horizontal form-material"
                id="loginform"
                action="javascript:void();"
                onSubmit={this.handleSubmit}
              >
                <h3 className="box-title m-b-20">
                  <img
                    src={config.logo}
                    style={{ width: "200px", paddingBottom: "15px" }}
                  />
                </h3>
                <small
                  style={{ position: "absolute", right: "20px", top: "13px" }}
                >
                  Zaměstnanci
                </small>
                <div className="form-group">
                  <div className="col-xs-12">
                    <input
                      className="form-control"
                      type="text"
                      required="required"
                      placeholder="Login"
                      name="login"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="col-xs-12">
                    <input
                      className="form-control"
                      type="password"
                      required="required"
                      placeholder="Heslo"
                      name="password"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group text-center m-t-20">
                  <div className="col-xs-12">
                    <button
                      className="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                      type="submit"
                    >
                      Přihlásit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default LoginForm;
